<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-YiShuYongPin`]" width="1em" height="1em" v-bind="$attrs"><path d="M19.5 2H4.5C3.125 2 2 3.125 2 4.5V19.5C2 20.875 3.125 22 4.5 22H19.5C20.875 22 22 20.875 22 19.5V4.5C22 3.125 20.875 2 19.5 2ZM20.75 19.5C20.75 20.25 20.25 20.75 19.5 20.75H4.5C3.75 20.75 3.25 20.25 3.25 19.5V4.5C3.25 3.75 3.75 3.25 4.5 3.25H19.5C20.25 3.25 20.75 3.75 20.75 4.5V19.5ZM19.25 12.75L17.375 11.5C17.125 11.375 16.875 11.375 16.625 11.5L13.625 13.875L9.25 10.875C9.25 10.875 9.125 10.875 9.125 10.75H9H8.875H8.75H8.625L4.875 13.25C4.5 13.5 4.375 13.875 4.625 14.25C4.75 14.375 4.875 14.5 5.125 14.5C5.25 14.5 5.375 14.5 5.5 14.375L8.875 12.125L18.5 18.75C18.625 18.875 18.75 18.875 18.875 18.875C19.125 18.875 19.25 18.75 19.375 18.625C19.625 18.375 19.5 18 19.25 17.75L14.75 14.625L17 12.75L18.5 13.75C18.625 13.875 18.75 13.875 18.875 13.875C19.125 13.875 19.25 13.75 19.375 13.625C19.625 13.25 19.5 12.875 19.25 12.75ZM13.5 10.125C15 10.125 16.25 8.875 16.25 7.375C16.25 5.875 15.125 4.5 13.5 4.5C12 4.5 10.75 5.75 10.75 7.25C10.75 8.75 12 10.125 13.5 10.125ZM13.5 5.75C14.375 5.75 15 6.5 15 7.25C15 8.125 14.25 8.75 13.5 8.75C12.75 8.875 12 8.125 12 7.25C12 6.5 12.75 5.75 13.5 5.75Z"/></svg>
</template>
<script>

export default {
  name: 'IconYiShuYongPin',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
